
<section class="overAuditGrid">&nbsp;

</section>
<datalist id="colors">
  <option>#000000</option>
  <option>#ffffff</option>
  <option>#81070e</option>
  <option>#8b4820</option>
  <option>#315050</option>
  <option>#007f7f</option>
  <option>#1c007c</option>
  <option>#51007e</option>
  <option>#696969</option>
  <option>#d9a636</option>
  <option>#006517</option>
  <option>#2c00c7</option>
  <option>#ff0e1b</option>
  <option>#00fffe</option>
  <option>#f47cea</option>
  <option>#ffa07d</option>
  <option>#fbff3f</option>
  <option>#00ff3a</option>
  <option>#aad6e4</option>
  <option>#d2d2d2</option>
  <option>#ffeff5</option>
  <option>#eefff0</option>
  <option>#e6e5f9</option>
</datalist>
<div>   <app-alert></app-alert></div>
<div id="notification-editor" class="notification-editor">

  <div class="content">

    <div class="reportConfigurationList">
      <div class="titlebar-div" id="titlebar-div">Template List</div>
      <app-configurable-link-list
      (linkClickedOutput)="changeSelectedListDetails($event)"
      [list]="templateList"
      >
      </app-configurable-link-list>

    </div>
    <div class="col2">
        <div class="titlebar-div" id="titlebar-div">{{selectedTemplate.Name}}</div>
      <div class="col2Top">
        <div class="inputBoxes">
          <label for="name">Name </label><label class="asterix">*</label><input type="text"   [(ngModel)]="selectedTemplate.Name"/><br/>
          <label for="email-to">From E-mail </label><label class="asterix">*</label><input id="email-to" type="text"   [(ngModel)]="selectedTemplate.ReplyTo"/><br/>
          <label for="email-cc">CC </label><label class="asterix" style="visibility:hidden">*</label><input id="email-cc" type="text"  [(ngModel)]="selectedTemplate.CC" /><br/>
          <label for="email-bcc">BCC </label><label class="asterix" style="visibility:hidden">*</label><input id="email-bcc" type="text"  [(ngModel)]="selectedTemplate.BCC" /><br/>
          <label for="email-subject">Subject </label><label class="asterix">*</label><input id="email-subject" type="text"  [(ngModel)]="selectedTemplate.Subject" /><br/>
        </div>
        <div class="PassFail">
            <div class="Pass" *ngIf="currentPath=='rate-audit' || currentPath=='rate-availability'">
                <span class="title">Passed Audit</span>
            </div>
            <div class="Fail" *ngIf="currentPath=='rate-audit' || currentPath=='rate-availability'">
                <span class="title">Failed Audit</span>
            </div>
            <div id="inputControls">
              <div *ngIf="currentPath=='rate-audit'">
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox" [(ngModel)]="selectedTemplate.SASendLoaded" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Loaded">
                      <input ngl type="radio" [checked]="selectedTemplate.SAPassLoaded" (click)="onPassLoadedChecked($event)" />
                    </ngl-radio-option>
                    <ngl-radio-option label="Loaded" class="inputControlsShorterRadioElement">
                      <input ngl type="radio" [checked]="selectedTemplate.SAFailLoaded" (click)="onFailLoadedChecked($event)" />
                    </ngl-radio-option>
                  </fieldset>
                </div>
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox" [(ngModel)]="selectedTemplate.SASendNotLoaded" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Not Loaded">
                      <input ngl type="radio" [checked]="selectedTemplate.SAPassNotLoaded" (click)="onPassNotLoadedChecked($event)" />
                    </ngl-radio-option>
                    <ngl-radio-option label="Not Loaded" class="inputControlsShorterRadioElement">
                      <input ngl type="radio" [checked]="selectedTemplate.SAFailNotLoaded" (click)="onFailNotLoadedChecked($event)" />
                    </ngl-radio-option>
                  </fieldset>
                </div>
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox" [(ngModel)]="selectedTemplate.SASendDiscrepancy" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Discrepancy">
                      <input ngl type="radio" [checked]="selectedTemplate.SAPassDiscrepancy" (click)="onPassDiscrepancyChecked($event)"  />
                    </ngl-radio-option>
                    <ngl-radio-option label="Discrepancy" class="inputControlsShorterRadioElement">
                      <input ngl type="radio" [checked]="selectedTemplate.SAFailDiscrepancy" (click)="onFailDiscrepancyChecked($event)" />
                    </ngl-radio-option>
                  </fieldset>
                </div>
              </div>
              <div *ngIf="currentPath=='rate-availability'">
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox" [(ngModel)]="selectedTemplate.RASendAvailable" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Available">
                      <input ngl type="radio" [checked]="selectedTemplate.RAPassAvailable" (click)="onPassAvailableChecked($event)" />
                    </ngl-radio-option>
                    <ngl-radio-option label="Available">
                      <input ngl type="radio" [checked]="selectedTemplate.RAFailAvailable" (click)="onFailAvailableChecked($event)" />
                    </ngl-radio-option>
                  </fieldset>
                </div>
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox" [(ngModel)]="selectedTemplate.RASendAvailableHigher" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Available Higher">
                      <input ngl type="radio" [checked]="selectedTemplate.RAPassAvailableHigher" (click)="onPassAvailableHigherChecked($event)" />
                    </ngl-radio-option>
                    <ngl-radio-option label="Available Higher">
                      <input ngl type="radio" [checked]="selectedTemplate.RAFailAvailableHigher" (click)="onFailAvailableHigherChecked($event)" />
                    </ngl-radio-option>
                  </fieldset>
                </div>
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox"  [(ngModel)]="selectedTemplate.RASendAvailableLower" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Available Lower">
                      <input ngl type="radio" [checked]="selectedTemplate.RAPassAvailableLower" (click)="onPassAvailableLowerChecked($event)" />
                    </ngl-radio-option>
                    <ngl-radio-option label="Available Lower">
                      <input ngl type="radio" [checked]="selectedTemplate.RAFailAvailableLower" (click)="onFailAvailableLowerChecked($event)" />
                    </ngl-radio-option>
                  </fieldset>
                </div>
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox"  [(ngModel)]="selectedTemplate.RASendRNA" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Rate Not Available">
                      <input ngl type="radio" [checked]="selectedTemplate.RAPassRNA" (click)="onPassRateNotAvailableChecked($event)"  />
                    </ngl-radio-option>
                    <ngl-radio-option label="Rate Not Available">
                      <input ngl type="radio" [checked]="selectedTemplate.RAFailRNA"  (click)="onFailRateNotAvailableChecked($event)" />
                    </ngl-radio-option>
                  </fieldset>
                </div>
                <div class="inputControlsRow">
                  <ngl-checkbox class="inputControlsCheckboxSpan">
                    <input ngl type="checkbox"  [(ngModel)]="selectedTemplate.RASendHNA" />
                  </ngl-checkbox>
                  <fieldset ngl-radio-group class="inputControlsRadioSpan">
                    <ngl-radio-option label="Hotel Not Available">
                      <input ngl type="radio" [checked]="selectedTemplate.RAPassHNA" (click)="onPassHotelNotAvailableChecked($event)"   />
                    </ngl-radio-option>
                    <ngl-radio-option label="Hotel Not Available">
                      <input ngl type="radio" [checked]="selectedTemplate.RAFailHNA" (click)="onFailHotelNotAvailableChecked($event)"  />
                    </ngl-radio-option>
                  </fieldset>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div class="col2CenterRow">
        <div class="file-options">
          <button class="k-button cvt-secondary" value="New" (click)="onNewTemplate()">New</button>
          <button class="k-button cvt-primary" value="Save" (click)="onSaveTemplate()">Save</button>
          <button class="k-button cvt-secondary" value="Default" (click)="onSetDefaultNotificationTemplate()" [disabled]="selectedTemplate.isDefault">Make Default</button>
        </div>

      </div>
      <div class="col2Bottom">

          <kendo-tabstrip [height]="'100%'">
            <kendo-tabstrip-tab class="'tab-txt'" [title]="''" [disabled]="true">
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab  [title]="disabled?'':'Audit Failed Template'" [selected]="!disabled" [disabled]="disabled">
              <ng-template kendoTabContent >
                <ckeditor
                id="ckeditorFailedAudit"
                [(ngModel)]="selectedTemplate.FailedAuditTemplate"
                [editorUrl] ="ckEditorUrl"
                >
              </ckeditor>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="auditPassedTile" [selected]="disabled">
              <ng-template kendoTabContent>
                <ckeditor
                id="ckeditorPassedAudit"
                [(ngModel)]="selectedTemplate.PassedAuditTemplate"
                >
                </ckeditor>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>

      </div>
    </div>
    <div class="col3">
      <div class="titlebar-div" id="titlebar-div">Data Elements and Settings</div>
      <div class="panelbar-wrapper">
        <kendo-panelbar [expandMode]="2" height="90%">
          <kendo-panelbar-item [title]="'Hotel Fields (click once to add)'" [expanded]="true">
            <ng-template kendoPanelBarContent>
              <div class="hotel-fields">
                <ul>
                  <li *ngIf="currentPath=='rate-audit'" (click)="ClickHotelField('ParentHotelChain')">Parent Hotel Chain</li>
                  <li (click)="ClickHotelField('CustomerName')">Customer Name</li>
                  <li *ngIf="currentPath!='reverse-audit'"  (click)="ClickHotelField('HotelName')">Hotel Name</li>
                  <li *ngIf="currentPath!='reverse-audit'" (click)="ClickHotelField('HotelAddress')">Address</li>
                  <li *ngIf="currentPath!='reverse-audit'" (click)="ClickHotelField('HotelCity')">City</li>
                  <li *ngIf="currentPath!='reverse-audit'" (click)="ClickHotelField('HotelState')">State</li>
                  <li *ngIf="currentPath!='reverse-audit'" (click)="ClickHotelField('HotelPostalCode')">Postal Code</li>
                  <li *ngIf="currentPath!='reverse-audit'" (click)="ClickHotelField('HotelCountry')">Country</li>
                  <li *ngIf="currentPath=='rate-audit'" (click)="ClickHotelField('ContactPhone')">Contact Phone</li>
                  <li *ngIf="currentPath=='reverse-audit'" (click)="ClickHotelField('DateOfSearch')">Date of Search</li>
                </ul>
              </div>
            </ng-template>
          </kendo-panelbar-item>
          <kendo-panelbar-item [title]="'Audit Result Data Grid'" [expanded]="true">
            <ng-template kendoPanelBarContent>
              <div class="data-grid">
                <table *ngIf="this.currentPath!='reverse-audit'" [class]="('data-grid-table' + (showGridLines?'':' data-grid-td-hidden-border'))">
                  <tr [ngStyle]="{color:headerTextForegroundColor,backgroundColor:headerTextBackgroundColor}">
                    <td [class]="('data-grid-td-top ' + (showGDSInfo?'data-grid-td-left':'data-grid-td-hidden'))">GDS</td>
                    <td [class]="('data-grid-td-top ' + (showGDSInfo?'':' data-grid-td-left'))">Date Checked</td>
                    <td *ngIf="currentPath=='rate-audit'" [class]="('data-grid-td-top ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Breakfast</td>
                    <td *ngIf="currentPath=='rate-audit'" [class]="('data-grid-td-top ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Internet</td>
                    <td *ngIf="currentPath=='rate-audit'" [class]="('data-grid-td-top ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Parking</td>
                    <td *ngIf="currentPath=='rate-audit'" [class]="('data-grid-td-top ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Transportation to Airport</td>
                    <td *ngIf="currentPath=='rate-audit'" [class]="('data-grid-td-top ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Local Office Transportation</td>
                    <td *ngIf="currentPath=='rate-audit'" [class]="('data-grid-td-top ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Bid Cancel Policy</td>
                    <td [class]="('data-grid-td-top ' + (showRateInfo?'':' data-grid-td-right'))">Status</td>
                    <td [class]="('data-grid-td-top ' + (showRateInfo?'data-grid-td-right':'data-grid-td-hidden'))">Price</td>
                  </tr>
                  <tr [ngStyle]="{color:gridTextForegroundColor,backgroundColor:gridTextBackgroundColor}">
                    <td [class]="(showGDSInfo?'data-grid-td-left':'data-grid-td-hidden')">Apollo</td>
                    <td [class]="(showGDSInfo?'':'data-grid-td-left')">1/1/1900</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="(showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden')">Y</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="(showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden')">N</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="(showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden')">N</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="(showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden')">Y</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="(showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden')">Y</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="(showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden')">1 Day</td>
                    <td [class]="(showRateInfo?'':'data-grid-td-right')">{{gridStatus1}}</td>
                    <td [class]="(showRateInfo?'data-grid-td-right':'data-grid-td-hidden')">00.00</td>
                  </tr>
                  <tr [ngStyle]="{color:gridTextForegroundColor,backgroundColor:gridTextBackgroundColor}">
                    <td [class]="('data-grid-td-bottom ' + (showGDSInfo?'data-grid-td-left':'data-grid-td-hidden'))">Sabre</td>
                    <td [class]="('data-grid-td-bottom ' + (showGDSInfo?'':' data-grid-td-left'))">1/1/1900</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="('data-grid-td-bottom ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Y</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="('data-grid-td-bottom ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">N</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="('data-grid-td-bottom ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">N</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="('data-grid-td-bottom ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Y</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="('data-grid-td-bottom ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">Y</td>
                    <td *ngIf="currentPath=='rate-audit'"[class]="('data-grid-td-bottom ' + (showAmenitiesPolicyInfo?'data-grid-td-left':'data-grid-td-hidden'))">1 Day</td>
                    <td [class]="('data-grid-td-bottom ' + (showRateInfo?'':' data-grid-td-right'))">{{gridStatus2}}</td>
                    <td [class]="('data-grid-td-bottom ' + (showRateInfo?' data-grid-td-right':' data-grid-td-hidden'))">00.00</td>
                  </tr>
                </table>
                <div class="data-grid-checkboxes">
                  <div>
                    <input
                    type="checkbox"
                    name="showGridLines"
                    [(ngModel)]="showGridLines"/>
                    Show Grid Lines
                  </div>
                  <div>
                    <input
                    type="checkbox"
                    name="ShowGDSInfo"
                    [(ngModel)]="showGDSInfo"
                    (ngModelChange)="ModelChangeShowGDSInfo()"/>
                    Show GDS Information
                  </div>
                  <div class="indentLeft">
                    <input
                    type="checkbox"
                    name="showGDSName"
                    [disabled]="!showGDSInfo"
                    [(ngModel)]="showGDSName"/>
                    Show GDS Name
                  </div>
                  <div class="indentLeft">
                    <input
                    type="checkbox"
                    name="showChainCode"
                    [disabled]="!showGDSInfo"
                    [(ngModel)]="showChainCode"/>
                    Show Chain Code
                  </div>
                  <div class="indentLeft">
                    <input
                    type="checkbox"
                    name="showPropCode"
                    [disabled]="!showGDSInfo"
                    [(ngModel)]="showPropCode"/>
                    Show Property Code
                  </div>
                  <div  *ngIf="currentPath=='reverse-audit'">
                    <input
                    type="checkbox"
                    name="ShowHotelInfo"
                    [(ngModel)]="showHotelInfo"
                    (ngModelChange)="ModelChangeShowHotelInfo()"/>
                    Show Hotel Information
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showHotelName"
                    [disabled]="!showHotelInfo"
                    [(ngModel)]="showHotelName"/>
                    Show Hotel Name
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showHotelAddress"
                    [disabled]="!showHotelInfo"
                    [(ngModel)]="showHotelAddress"/>
                    Show Address
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showHotelCity"
                    [disabled]="!showHotelInfo"
                    [(ngModel)]="showHotelCity"/>
                    Show City
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showHotelState"
                    [disabled]="!showHotelInfo"
                    [(ngModel)]="showHotelState"/>
                    Show State
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showHotelCountry"
                    [disabled]="!showHotelInfo"
                    [(ngModel)]="showHotelCountry"/>
                    Show Country
                  </div>
                  <div class="{{RACClass}}">
                    <input
                    type="checkbox"
                    name="showRateAccessCode"
                    [disabled]="!RACDisabled"
                    [(ngModel)]="showRateAccessCode"/>
                    Show Rate Access Code
                  </div>
                  <div *ngIf="currentPath!='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showRateInfo"
                    [(ngModel)]="showRateInfo"
                    (ngModelChange)="ModelChangeShowRateInfo()"/>
                    Show Rate Information
                  </div>
                  <div class="indentLeft" *ngIf="currentPath!='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showCurrencyCode"
                    [disabled]="!showRateInfo"
                    [(ngModel)]="showCurrencyCode"/>
                    Show Currency Code
                  </div>
                  <div class="indentLeft" *ngIf="currentPath!='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showExpectedRate"
                    [disabled]="!showRateInfo"
                    [(ngModel)]="showExpectedRate"/>
                    Show Expected Rate
                  </div>
                  <div class="indentLeft" *ngIf="currentPath!='reverse-audit'">
                    <input
                    type="checkbox"
                    name="showProvidedRate"
                    [disabled]="!showRateInfo"
                    [(ngModel)]="showProvidedRate"/>
                    Show Provided Rate
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showWithCommission"
                    [disabled]="!showRateInfo"
                    [(ngModel)]="showWithCommission"/>
                    Show Has Commission
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showPercentCommission"
                    [disabled]="!showRateInfo"
                    [(ngModel)]="showPercentCommission"/>
                    Show Percent Commission
                  </div>
                  <div *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showAmenitiesPolicyInfo"
                    [(ngModel)]="showAmenitiesPolicyInfo"
                    (ngModelChange)="ModelChangeshowAmenitiesPolicyInfo()"/>
                    Show Amenities and Policy
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showBreakfast"
                    [disabled]="!showAmenitiesPolicyInfo"
                    [(ngModel)]="showBreakfast"/>
                    Show Breakfast
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showInternet"
                    [disabled]="!showAmenitiesPolicyInfo"
                    [(ngModel)]="showInternet"/>
                    Show Internet
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showParking"
                    [disabled]="!showAmenitiesPolicyInfo"
                    [(ngModel)]="showParking"/>
                    Show Parking
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showAirportTransport"
                    [disabled]="!showAmenitiesPolicyInfo"
                    [(ngModel)]="showAirportTransport"/>
                    Show Transportation to Airport
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showLocalTransport"
                    [disabled]="!showAmenitiesPolicyInfo"
                    [(ngModel)]="showLocalTransport"/>
                    Show Local Office Transportation
                  </div>
                  <div class="indentLeft" *ngIf="currentPath=='rate-audit'">
                    <input
                    type="checkbox"
                    name="showBidCancelPolicy"
                    [disabled]="!showAmenitiesPolicyInfo"
                    [(ngModel)]="showBidCancelPolicy"/>
                    Show Bid Cancel Policy
                  </div>
                  <div>
                    <input
                    type="color"
                    list="colors"
                    [(ngModel)]="headerTextForegroundColor"/>
                    Header Text Foreground Color
                  </div>
                  <div>
                    <input
                    type="color"
                    list="colors"
                    [(ngModel)]="headerTextBackgroundColor"/>
                    Header Text Background Color
                  </div>
                  <div>
                    <input
                    type="color"
                    list="colors"
                    [(ngModel)]="gridTextForegroundColor"/>
                    Grid Text Foreground Color
                  </div>
                  <div>
                    <input
                    type="color"
                    list="colors"
                    [(ngModel)]="gridTextBackgroundColor"/>
                    Grid Text Background Color
                  </div>
                </div>
                <div class="addGridButton">
                  <button
                  class="k-button cvt-secondary"
                  (click)="ClickAddGridToTemplate()">Add Grid to Template</button>
                </div>
              </div>
            </ng-template>
          </kendo-panelbar-item>
        </kendo-panelbar>
      </div>
    </div>
  </div>
  <app-spinner [isBusy]="isBusy"></app-spinner>
